import { useAuth } from '../utils/auth';

export default function useIsAuthenticated() {
  return useAuth().isAuthenticated;
}
